'use client'

import { useEffect } from 'react'
import { fetchDeepLink } from '@services/fetchDeepLink'
import WhatsappChallanFlow from '@components/WhatsappChallanFlow/whatsappChallanFlow'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import WhatsappChallanNewFlow from './WhatsappChallanNewFlow'
import { WA_CHALLAN_OLD_FLOW_LEADS, WA_CHALLAN_REDIRECTION_LEADS, defaultDeeplink } from './constants'
import { IWhatsappChallanNewFlow } from './interfaces'

const WhatsappChallanWrapper = ({
  regNum,
  widgetType,
  phoneNumber,
  utmLead,
  segmentEventCommonProperties,
}: IWhatsappChallanNewFlow) => {
  useEffect(() => {
    void (async () => {
      if (WA_CHALLAN_REDIRECTION_LEADS.includes(utmLead)) {
        let url = defaultDeeplink
        const deepLink = await fetchDeepLink({ regNo: regNum, widgetType, mobileNo: phoneNumber })
        if (deepLink) url = deepLink
        window.location.href = url
      }
    })()
  }, [])

  if (WA_CHALLAN_REDIRECTION_LEADS.includes(utmLead)) return null

  return (
    <PropertyControlledComponent
      controllerProperty={WA_CHALLAN_OLD_FLOW_LEADS.includes(utmLead)}
      fallback={
        <WhatsappChallanNewFlow
          regNum={regNum}
          phoneNumber={phoneNumber}
          utmLead={utmLead}
          segmentEventCommonProperties={segmentEventCommonProperties}
          widgetType={widgetType}
        />
      }>
      <WhatsappChallanFlow
        regNum={regNum}
        phoneNumber={phoneNumber}
        segmentEventCommonProperties={segmentEventCommonProperties}
        widgetType={widgetType}
      />
    </PropertyControlledComponent>
  )
}

export default WhatsappChallanWrapper
